import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';
import React, { useContext } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import Footer, { footerHeight } from 'components/Footer';
import Header from 'components/Header';
import { drawerWidthClosed, drawerWidthOpened, drawerWidthOpenedSubMenu } from 'components/Menu/Menu';
import { MenuContext } from 'menuContext';
import Menu from 'components/MenuCiteo';
import { default as SuperAdminMenu } from 'components/Menu/Menu';
import { autoriserAcces } from '../utils/user';
import { UserRole } from '../types';
import { AppContext } from '../context';

const useStyles = makeStyles(theme => ({
  content: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '2rem',
    paddingRight: '2rem',
    marginBottom: footerHeight,
    paddingTop: '8.4rem',
    background: 'linear-gradient(313.13deg, #F5F5F5 39.8%, #FFFFFF 62.33%)',
    minHeight: 'calc(100vh - 20px)',
    transition: 'all 0.3s ease',
    '& h2': {
      marginTop: 0,
    },
  },
  contentMenuOpen: {
    marginLeft: drawerWidthOpened,
  },
  contentMenuOpenWithSubMenu: {
    marginLeft: drawerWidthOpenedSubMenu,
  },
  contentNoMenu: {
    marginLeft: 0,
    paddingLeft: 0,
  },
  contentMenuClosed: {
    marginLeft: drawerWidthClosed,
  },
  title: {
    marginBottom: '1rem',
  },
}));

interface Props {
  noMenu?: boolean;
  children?: any;
}

const Layout: React.FC<Props> = ({ noMenu, children }) => {
  const classes = useStyles();
  const { open, submenuIsOpen } = useContext(MenuContext);
  const { t } = useTranslation();
  const context = useContext(AppContext);
  const roles = context.getRoles();
  const isSuperAdmin = autoriserAcces(roles, UserRole.ROLE_SUPER_ADMIN);

  const contentClasses = [
    classes.content,
    !noMenu &&
      (open && !submenuIsOpen
        ? classes.contentMenuOpen
        : submenuIsOpen
        ? classes.contentMenuOpenWithSubMenu
        : classes.contentMenuClosed),
    noMenu && classes.contentNoMenu,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <>
      <Header />
      {!noMenu && !isSuperAdmin && <Menu />}
      {!noMenu && isSuperAdmin && <SuperAdminMenu open={open} setOpen={submenuIsOpen} />}
      <div className={contentClasses}>
        <ErrorBoundary
          fallbackRender={({ error }) => (
            <Alert severity="error">
              <AlertTitle>{t('errorGeneric')}</AlertTitle>
              <pre>{error.message}</pre>
            </Alert>
          )}
        >
          {children}
        </ErrorBoundary>
      </div>
      <Footer />
    </>
  );
};
export default React.memo(
  Layout,
  (prevProps, nextProps) => prevProps.noMenu === nextProps.noMenu && prevProps.children === nextProps.children,
);
